// src/socketListener.js (optional new file)
import { useEffect } from "react";
import socket from "./socket";
import { toast } from "react-toastify";

export default function useSocketNotifications() {
  useEffect(() => {
    socket.on("connect", () => {
      console.log("🟢 Connected to WebSocket:", socket.id);
    });

    socket.on("orderNotification", (payload) => {
      console.log("🔔 Notification received on client:", payload);

      // Example visual feedback (optional)
      toast.success(`Order update: ${payload.status?.toUpperCase()}`);
    });

    socket.on("disconnect", () => {
      console.log("🔴 Disconnected from WebSocket");
    });

    return () => {
      socket.off("orderNotification");
      socket.off("connect");
      socket.off("disconnect");
    };
  }, []);
}
